import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { footer } from '../../content/siteCopy';
import './SiteFooter.css';

function SiteFooter() {
  // The homepage hydrates from a shell prerendered at build time, so the first
  // client render has to match that markup exactly. Reading the clock during
  // render would disagree with the baked year the moment a deployed build
  // crosses into January, and React 19 answers a hydration mismatch by throwing
  // the prerendered tree away. Resolving the year after mount keeps the first
  // render deterministic and keeps the shell artifact free of any date, so it
  // cannot drift. Until the effect runs — and for readers without JavaScript —
  // the range falls back to copy.footer.copyright.yearBeforeLoad.
  const [currentYear, setCurrentYear] = useState(null);

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  const { startYear, holder, yearBeforeLoad } = footer.copyright;

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div>
          <p className="site-footer__brand">{footer.brand}</p>
          <p className="site-footer__statement">{footer.statement}</p>
        </div>

        <nav className="site-footer__nav" aria-label="Footer navigation">
          {footer.navigation.map(item => (
            <Link key={item.to} to={item.to}>
              {item.label}
            </Link>
          ))}
        </nav>

        <p className="site-footer__copyright">
          {`© ${startYear}–${currentYear ?? yearBeforeLoad} ${holder}.`}
        </p>
      </div>
    </footer>
  );
}

export default SiteFooter;
